import { bootstrapPortal } from "@/shared/app/bootstrapPortal";
import HospitalApp from "./App.hospital";

bootstrapPortal("hospital", <HospitalApp />);
